import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  SelfServiceContainerDto, SelfServiceContainerOverviewDto,
  SelfServiceContainerSearchRequest,
  UpsertSelfServiceContainerDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/self-service-container`;

export const getContainers = (
    mandateId: number,
    source: CancelTokenSource): Promise<Array<SelfServiceContainerDto>> => {

  return axios
      .get(apiUri, {params: {mandateId: mandateId}, cancelToken: source.token})
      .then(response => response.data);
};

export const getContainersOverview = (
    mandateId: number,
    source: CancelTokenSource): Promise<Array<SelfServiceContainerOverviewDto>> => {

  return axios
      .get(`${apiUri}/overview/${mandateId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchContainers = (containerSearchRequest: Partial<SelfServiceContainerSearchRequest>,
                                 source: CancelTokenSource): Promise<Array<SelfServiceContainerOverviewDto>> => {
  return axios
      .post(`${apiUri}/search`, containerSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
}

export const findContainerById = (
    id: string, source: CancelTokenSource): Promise<UpsertSelfServiceContainerDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const addContainer = (
    upsertSelfServiceContainerDto: Partial<UpsertSelfServiceContainerDto>,
    source: CancelTokenSource)
    : Promise<SelfServiceContainerDto> => {

  return axios
      .post(apiUri, upsertSelfServiceContainerDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editContainer = (
    id: string,
    upsertSefServiceContainerDto: Partial<UpsertSelfServiceContainerDto>,
    source: CancelTokenSource)
    : Promise<SelfServiceContainerDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertSefServiceContainerDto, {cancelToken: source.token})
      .then(response => response.data)
};
